module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['item-block', _vm.className],
    attrs: {
      "data-json": JSON.stringify(_vm.data)
    }
  }, [(typeof _vm.data.itemHash !== 'undefined' && _vm.getItemDef(_vm.data)) ? _c('div', {
    class: _vm.itemClass(_vm.data),
    style: ('background-image:url(https://www.bungie.net' + _vm.getItemDef(_vm.data).displayProperties.icon + ')')
  }) : (_vm.data.progressionHash === 540048094) ? _c('div', {
    staticClass: "borderless-item",
    style: ('background-image:url(https://www.bungie.net' + _vm.getItemDef({
      itemHash: 1460578929
    }).displayProperties.icon + ')'),
    attrs: {
      "data-json": JSON.stringify(_vm.getItemDef({
        itemHash: 1460578929
      }))
    }
  }) : (typeof _vm.data.progressionHash !== 'undefined' && _vm.getProgressionDef(_vm.data).factionHash) ? _c('div', {
    staticClass: "borderless-item",
    style: ('background-image:url(https://www.bungie.net' + _vm.getFactionDef(_vm.getProgressionDef(_vm.data)).displayProperties.icon + ')')
  }) : (typeof _vm.data.progressionHash !== 'undefined' && _vm.getProgressionDef(_vm.data)) ? _c('div', {
    staticClass: "borderless-item",
    style: ('background-image:url(https://www.bungie.net' + _vm.getProgressionDef(_vm.data).displayProperties.icon + ')')
  }) : (typeof _vm.data.factionHash !== 'undefined' && _vm.getFactionDef(_vm.data)) ? _c('div', {
    staticClass: "borderless-item",
    style: ('background-image:url(https://www.bungie.net' + _vm.getFactionDef(_vm.data).displayProperties.icon + ')')
  }) : _vm._e(), _vm._v(" "), (typeof _vm.data.objectives !== 'undefined') ? _c('div', {
    staticClass: "primary-stat"
  }, [_vm._v(_vm._s(_vm.itemObjectivePercentage(_vm.data.objectives)) + "%")]) : (typeof _vm.data.primaryStat !== 'undefined') ? _c('div', {
    class: ['primary-stat', _vm.data.damageTypeHash && _vm.getDamageDef(_vm.data).displayProperties.name.toLowerCase()]
  }, [_vm._v(_vm._s(_vm.data.primaryStat.value))]) : (typeof _vm.data.currentProgress !== 'undefined') ? _c('div', {
    staticClass: "primary-stat"
  }, [_vm._v(_vm._s(_vm.data.currentProgress))]) : _c('div', {
    staticClass: "primary-stat"
  }, [_vm._v(_vm._s(_vm.data.quantity || 1))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66e76fac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e76fac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 58
// module chunks = 0 1